import { AnimationOptions } from 'ngx-lottie';
import { TIPO_ERROR } from './errores.constants';

const info: AnimationOptions = {
  path: 'assets/json/empty-state/fullpage_info.json',
  autoplay: true,
  loop: true
};

const warning: AnimationOptions = {
  path: 'assets/json/empty-state/fullpage-warning.json',
  renderer: 'svg',
  autoplay: true,
  loop: true
};

const error: AnimationOptions = {
  path: 'assets/json/empty-state/fullpage-error.json',
  autoplay: true,
  loop: true
};

const success: AnimationOptions = {
  path: 'assets/json/empty-state/fullpage_succes.json',
  autoplay: true,
  loop: true
};

export const CONFIG = {
  [TIPO_ERROR.ERROR]: error,
  [TIPO_ERROR.INFO]: info,
  [TIPO_ERROR.SUCCESS]: success,
  [TIPO_ERROR.WARNING]: warning
};

export const CONFIG_URL_CAPTCHA = {
  url_captcha_terms: 'https://www.google.com/intl/es/policies/terms/',
  url_captcha_privacy: 'https://www.google.com/intl/es/policies/privacy/'
};
